const GIGABYTE = 1e3 * 1e3 * 1e3;
var file_size_default = {
  GIGABYTE
};
export {
  GIGABYTE,
  file_size_default as default
};
